import React from 'react'
import { Link } from 'react-router-dom'

const Button = ({ eateries }) => { 
  return (
    <div className="buttonGroup">
        <Link className="Button" to={`/Menu/${eateries.id}`}>More Details</Link>
    </div>
  )
}

export default Button